export default () => {
  window.addEventListener('load', () => {

    document.getElementById('app-main').style.paddingBottom =
      document.getElementById('app-footer').clientHeight + 'px'

  })

  // cocoon は「削除マーク済み（_destroy 立ち）の行をページ読み込み時に隠す」処理を同梱しているが、
  // その登録先が `$(document).on("ready page:load turbolinks:load")` であり、
  // jQuery 3 で ready イベントが廃止され、Turbolinks も使っていない本アプリでは1つも発火しない。
  // そのため更新失敗の再描画時に、削除したはずの行が表示に戻ってしまう（IH-1300）。
  // cocoon が出力する destroyed クラスを頼りに、同等の処理をここで行う。
  //
  // 非表示はクラスではなくインラインの display で行うこと。端末機種の「反映」
  // （libraries/terminal-model-load.js）は element.style.display = null で行を復活させるため、
  // クラスで隠すと反映し直しても行が戻らなくなる。
  //
  // data-wrapper-class は現状どのビューからも出力されていないが、cocoon と同じ解決規則を保つため
  // 分岐を残す。ファイル添付欄（ラッパーが .image-control）を cocoon の wrapper_class 対応に
  // 直した際、この JS を触らずにそのまま効かせるための余地でもある。
  document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.remove_fields.existing.destroyed')).forEach(el => {
      const row = el.closest(`.${el.dataset.wrapperClass || 'nested-fields'}`)
      if (row) row.style.display = 'none'
    })
  })

  document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.getElementsByClassName('nav-link')).forEach(el => {
      if (el.className.indexOf("nav-store-config") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-store-config')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-report") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-report')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-complaints") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-complaints')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-services") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-services')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
      if (el.className.indexOf("nav-operations") >= 0) {
        el.addEventListener('click', (e) => {
          Array.from(document.getElementsByClassName('nav-sub-operations')).forEach(els => {
            if (els.style.display === "none") els.style.display = "block"
            else els.style.display = "none"
          })
        })
      }
    })
  })
}
